import axios from 'axios';

export default {
    getClientToken(cb, { ClientId, ClientSecret }) {
        axios
            .post('https://midwest-beltone-com-iframes-prod.azurewebsites.net/api/ClientToken', { ClientId, ClientSecret }, {
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    }
};
